export default __webpack_public_path__ + "static/media/panque-nuez.74cc04fb.jpg";